import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Starfield from "@/components/Starfield";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Science from "@/pages/Science";
import TransformationKit from "@/pages/TransformationKit";
import TrifitXps from "@/pages/TrifitXps";
import Trifinity from "@/pages/Trifinity";
import About from "@/pages/About";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.5, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  return (
    <div className="bg-ink text-fog min-h-screen font-body">
      <BrowserRouter>
        <ScrollToTop />
        <Starfield />
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/trifit-xps" element={<TrifitXps />} />
          <Route path="/trifinity" element={<Trifinity />} />
          <Route path="/science" element={<Science />} />
          <Route
            path="/transformation-kit"
            element={<TransformationKit />}
          />
          <Route path="/about" element={<About />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
